import React from 'react'
import { LinkedinShareButton } from 'react-share'
import styled from 'styled-components'
import { LinkedinIcon } from '../../Svg'
import { ShareButtonProps } from './types'

const StyledIcon = styled(LinkedinIcon)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray6};
`

const LinkedinShare: React.FC<ShareButtonProps> = ({ url, title }) => {
  return (
    <LinkedinShareButton url={url} title={title}>
      <StyledIcon />
    </LinkedinShareButton>
  )
}

export default LinkedinShare
